import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEnterSubmit } from './common'
import { Button } from '../ui/button'
import { Mail } from 'lucide-react'
import { AuthCard, AuthTextInput } from './auth_card'

interface ForgetPasswordFormProps {
    onSubmit: (email: string) => void
    loading: boolean
}

export const ForgetPasswordForm = ({ onSubmit, loading }: ForgetPasswordFormProps) => {
    const [email, setEmail] = useState('')

    const submit = () => {
        if (onSubmit) {
            onSubmit(email)
        }
    }

    const onEnter = useEnterSubmit(submit)
    return (
        <AuthCard
            title="Reset password"
            subtitle={
                <Link className="font-medium text-gray-600 hover:text-[#2d72d2]" to="/login">
                    Back to login
                </Link>
            }
        >
            <AuthTextInput
                value={email}
                placeholder="Email address"
                disabled={loading}
                onChange={setEmail}
                onKeyDown={onEnter}
                icon={<Mail />}
            />

            <div>
                <Button
                    loading={loading}
                    intent="primary"
                    type="submit"
                    text="Send reset link"
                    onClick={submit}
                    fill
                    className="h-[37px]"
                />
            </div>
        </AuthCard>
    )
}
